<template>
	<div class="container">
		<ItemLogo></ItemLogo>
		<div style="background-color: #fafafa;">
			<div class="commonweal-logo alignLeft">
				<span id="wall-title" class="beforeitem weight600">志愿风采</span>
			</div>
			<VerticalFall :volunteerImgs="volunteerImgs" :Imgs='imgs'></VerticalFall>
		</div>
	</div>
</template>

<script>
	import ItemLogo from '@/components/index/ItemLogo.vue';
	import VerticalFall from '@/components/index/VerticalFall.vue';
	import {getVolunteerImgs} from '@/api/article';
	import {getOpenId} from '@/api/login';
	import request from '@/utils/request';
	export default {
		name: 'Index',
		components: {
			ItemLogo, VerticalFall
		},
		data(){
			return{
				param:{
					page:1,
					pagesize:20,
					type: 1,
				},
				volunteerImgs:[],
				imgs:[],
				code:''
			};
		},
		created(){
			this.getMyOpenId();
		},
		mounted() {
			this.GetImgs();
			localStorage.setItem('paymentChannel', '1');
		},
		methods:{
			GetImgs(){
				getVolunteerImgs(this.param).then(res => {
					var _data = res.data;
					//console.log(_data);
					if(_data.errcode=='1'){
						this.volunteerImgs = _data.data;
						for (var i = 0; i < this.volunteerImgs.length; i++) {
							this.imgs.push(this.volunteerImgs[i].s_img)
						}
					}
				});
			},
			//授权第一步获取Code
			getOrlCode:function(appid){
				let local = window.location.href;
				this.code = this.getUrlCode().code;
				if (this.code == null || this.code === '') { 
					var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+ appid +"&redirect_uri=" + encodeURIComponent(local) + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
					window.location.href = url;
					this.code = this.getUrlCode().code;
				}
			},
			getUrlCode(){
				var url = location.search;
                var theRequest = new Object();
                if (url.indexOf("?") != -1) {
                    var str = url.substr(url.indexOf("?")+1);
                    var strs = str.split("&");
                    for(var i = 0; i < strs.length; i ++) {
                        theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1]);
                    }
                }
                return theRequest;
			},
			//获取用户的openid
			getMyOpenId(){
				var openId = localStorage.getItem("myOpenId");
				/* if(openId==null||openId==''){
					let appid = 'wx9699d2291b1dab5f';
					this.getOrlCode(appid);
					getOpenId({code: this.code, state: 1}).then(res => {
						let _data = res.data;
						// console.log(_data);
						if (_data.errcode=='1') {
							localStorage.setItem( "myOpenId",_data.openid)
						} 
					}); 
				} */
			},
		}, 
	}
</script>

<style>
	@media screen and (min-width:50rem) {
		.container{
			width: 800px;
			margin: 0 auto;
		}
	}
	.commonweal-logo{
		width: 100%;
		margin: 0.5em auto;
        padding-top: 0.5em;
	}
	.commonweal-logo img{
		width: 60%;
	}
	#wall-title{
		font-size: 18px;
		letter-spacing: 0.25em;
		padding-left: 1em;
		color: #666666;
	}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue